// import React from 'react';
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

// import finalLogo from "../assets/img/finalLogo.png";

import feature_bg_51 from "../assets/img/update_2/bg/feature_bg_51.jpg";

const Footer = ({homepage}) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <footer
        className="footer-wrapper footer-layout5"
        style={{ backgroundImage: `url(${feature_bg_51})`, marginTop: "10px" }}
      >
        {/* <div
          className="widget-area py-0"
          style={{
            backgroundColor: "white",
            borderLeft: "100px solid #0f1138",
            borderRight: "88px solid #0f1138",
          }}
        > */}
          <div
            className="container"
            style={{
              backgroundColor: "#fff",
              // paddingTop: "40px",
              // paddingBottom: "20px",
              // marginBottom: "-75px",
            }}
          >
            <div
              className="row"
              style={{ 
                // marginBottom: "-20px",
                //  marginTop: "-175px",
                 display: "flex", alignItems: "stretch" }}
            >
              <div className="col-md-6 ">
                <div
                  className="box-icon-4 text-center"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    padding: "0px 0px 0px 0px",
                    marginBottom: "30px",
                    transition: "background-color 0.3s, color 0.3s",
                    background: "#eff3f6",
                    color: "black",
                     flex: 1,
                  }}
                >
                  <div
                    className="body-content hoveringeffect"
                    style={{ padding: "10px 0" }}
                  >
                    <div
                      className="heading"
                      style={{
                        fontWeight: "bold",
                        fontSize: "25px",
                        marginBottom: "10px",
                        fontFamily: "helvetica",
                        color: "#0f1138",
                      }}
                    >
                      CORPORATE & REGISTERED OFFICE
                    </div>
                    <p
                    className="mb-0"
                      style={{
                        fontSize: "14px",
                        color: "#212529ed",
                        fontFamily: "helvetica",
                      }}
                    >
                      C-8/2 GF, <br/>Vasant Vihar New Delhi -110057
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 ">
                <div
                  className="box-icon-4 text-center"
                  style={{

                    border: "1px solid #ccc",
                    borderRadius: "10px",                    
                    padding: "0px 0px 0px 0px",
                    marginBottom: "30px",
                    transition: "background-color 0.3s, color 0.3s",
                    background: "#eff3f6",
                    color: "black",
                    flex: 1,
                  }}
                >
                  <div
                    className="body-content hoveringeffect"
                    style={{ padding: "10px 0" }}
                  >
                    <div
                      className="heading"
                      style={{
                        fontWeight: "bold",
                        fontSize: "25px",
                        marginBottom: "10px",
                        fontFamily: "helvetica",
                        color: "#0f1138",
                      }}
                    >
                      FACTORY ADDRESS
                    </div>
                    <p
                    className="mb-0"
                      style={{
                        fontSize: "14px",
                        color: "#212529ed",
                        fontFamily: "helvetica",
                      }}
                    >
                      Newryan Global Private Limited, Plot No. 74-75, AKVN, Growth Center, Malanpur, Industrial Area, Bhind-477001, Madhya Pradesh, India
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-4">
                                <div className="box-icon-4 text-center" style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '20px', marginBottom: '30px', transition: 'background-color 0.3s, color 0.3s', background: '#eff3f6', color: 'black' }}>
                                    <div className="body-content hoveringeffect" style={{ padding: '10px 0' }}>
                                        <div className="heading" style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '10px' }}>REGISTERED OFFICE</div>
                                        <p style={{ fontSize: '14px', color: '#212529ed' }}>4 Basant Lok, Third Floor, Priya Market Vasant Vihar, New Delhi-110057</p>
                                    </div>
                                </div>
                            </div> */}
            </div>
          </div>
        {/* </div> */}
        <div className="widget-area">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-6 col-xl-6">
                <div className="widget footer-widget">
                  <h3 className="widget_title">
                    <div className="menu-area">
                      <div className="container">
                        <div className="row align-items-center justify-content-between">
                          <div className="col-auto">
                            <div className="header-logoxxx">
                              <a href="/">
                              {homepage ? (
                                <img
                                  // src="../assets/img/yumheader.svg"
                                  src="assets/img/yumheader.svg"
                                  alt="YUMWAY"
                                  style={{
                                    height: "60px",
                                    marginBottom: "50px",
                                  }}
                                />

                              ) : (

                                <img
                                  // src="../assets/img/yumheader.svg"
                                  src="assets/img/yumheader.svg"
                                  alt="YUMWAY"
                                  style={{
                                    height: "60px",
                                    marginBottom: "50px",
                                  }}
                                />                                
                              )}

                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </h3>
                  <div className="th-widget-about">
                    <p
                      className="about-text"
                      style={{ fontFamily: "helvetica" }}
                    >
                      Yumway is a trusted global exporter of premium frozen foods, with a strong focus on quality, taste, and freshness. Specializing in processed snacks and ready-to-eat frozen meals, we bring innovation and excellence to every bite. Operating from our advanced facility in Gujarat, our dedicated team ensures top-tier standards in production, packaging, and international delivery.
                    </p>
                    <div className="th-social">
                      <a
                        href="https://www.facebook.com/share/yhbpDtnYReppzRBs/?mibextid=qi2Omg"
                        style={{ background: "#F0B323" }}
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/icedream-global/"
                        style={{ background: "#F0B323" }}
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                      <a
                        href="https://www.instagram.com/icedreamglobal?igsh=bjU1am1mdTZ3bHNt"
                        style={{ background: "#F0B323" }}
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-xl-auto">
                <div className="widget widget_nav_menu footer-widget">
                  <h3
                    className="widget_title"
                    style={{ fontFamily: "helvetica" }}
                  >
                    Useful Links
                  </h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu" style={{ fontFamily: "helvetica" }}>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      {/* <li>
                        <Link to="/infrastructure">Infrastructure</Link>
                      </li> */}
                      <li>
                        <Link to="/product">Products</Link>
                      </li>
                      {/* <li>
                        <Link to="/quality">Quality</Link>
                      </li> */}

                        <li >
                            <Link to="/exports">Exports</Link>
                        </li>

                        <li>
                            <Link to="/quality">Quality</Link>
                        </li>                             
                      <li>
                        <Link to="/contactus">Contact Us</Link>
                      </li>
                      <li>
                        <a href="https://yumwayfood.com/blogs/" target="_blank" rel="noopener noreferrer">
                          Blogs
                        </a>
                      </li>
                    

                      {/* <li>
                        <Link to="/careers">Careers</Link>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto">
                <div className="widget footer-widget">
                  <h3
                    className="widget_title"
                    style={{ fontFamily: "helvetica" }}
                  >
                    Our Location
                  </h3>
                  <div className="recent-post-wrap">
                    {/* <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.0801193980747!2d72.85354431424533!3d21.02947999313118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0571ccb4b8867%3A0x7ec244669086e859!2sHN%20Indigos%20Private%20Limited!5e0!3m2!1sen!2sin!4v1626090743148!5m2!1sen!2sin"
                      width="100%"
                      height="200"
                      style={{ border: "0" }}
                      allowFullScreen
                      loading="lazy"
                      title="Iframe"
                    ></iframe> */}
                    <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d5096.15147273492!2d78.28951016866098!3d26.350742136296407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDIxJzAxLjQiTiA3OMKwMTcnMjQuMCJF!5e0!3m2!1sen!2sin!4v1757678468518!5m2!1sen!2sin" width="100%" height="200" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>                     
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-lg-6" style={{ fontFamily: "helvetica" }}>
                <p
                  className="copyright-text"
                  style={{ fontFamily: "helvetica" }}
                >
                  {" "}
                  <i className="fal fa-copyright "></i>
                  2025 Yumway by&nbsp;
                  <a
                    href="https://www.veravalonline.com"
                    target="_blank"
                    style={{ fontFamily: "helvetica" }} rel="noreferrer"
                
                  >
                    Veravalonline Pvt. Ltd.
                  </a>
                  &nbsp;-&nbsp;All Rights Reserved
                </p>
              </div>
              <div className="col-lg-6 text-end d-none d-lg-block">
                <div className="footer-links">
                  <ul>
                    <li>
                      {/* <a href="/privacypolicy" style={{ fontFamily: "helvetica" }}>
                        Privacy Policy
                      </a> */}
                        <Link to="/privacypolicy" style={{ fontFamily: "helvetica" }}>Privacy Policy</Link>
                    </li>
                    <li>
                      {/* <a href="#" style={{ fontFamily: "helvetica" }}>
                        Terms & Condition
                      </a> */}
                        <Link to="/termsandCondition" style={{ fontFamily: "helvetica" }}>Terms & Condition</Link>

                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
